import { Link } from 'react-router-dom';

export function NotFound(): JSX.Element {
  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="max-w-md mb-card p-8 text-center">
        <div className="mb-2 text-3xl font-display font-semibold text-mb-text">404</div>
        <div className="mb-6 text-sm text-mb-text-muted">
          That page doesn&rsquo;t exist. Check the URL, or go back to the dashboard.
        </div>
        <Link to="/dashboard" className="mb-btn-primary">
          Back to dashboard
        </Link>
      </div>
    </div>
  );
}
